import React, { useState, useEffect } from "react";
import "./faq.css";
import AOS from "aos";
import "aos/dist/aos.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // Toggle Question
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Initialize AOS Animation
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // ---- Fazo Academy FAQs ----
  const academyFAQs = [
    {
      q: "1. What programs does Fazo Academy offer?",
      a: "Fazo Academy offers a wide range of programs including software development, data science, digital marketing, and more. Our flagship program is the testing training course.",
    },
    {
      q: "2. Are the courses at Fazo Academy accredited?",
      a: "Yes, our courses are accredited and recognized within the industry. We maintain high standards of education and curriculum development.",
    },
    {
      q: "3. Is financial aid available for students?",
      a: "Yes, Fazo Academy offers flexible payment options and financial aid for eligible students, including scholarships and grants.",
    },
    {
      q: "4. Are there any prerequisites for enrolling in courses?",
      a: "Prerequisites vary depending on the course. Some may require prior knowledge or experience. Our counselors can guide you accordingly.",
    },
    {
      q: "5. Do you offer job placement assistance?",
      a: "Yes, Fazo Academy provides job placement assistance through career services, resume workshops, and interview training.",
    },
  ];

  // ---- Automation Testing FAQs ----
  const dataAnalysisFAQs = [
  {
    q: "1. What is the Data Analysis Course at Fazo Academy?",
    a: "It is a comprehensive program covering data cleaning, data visualization, SQL, Excel, Python, and business analytics techniques for real-world data analysis.",
  },
  {
    q: "2. Who is the Data Analysis course suitable for?",
    a: "It is suitable for beginners, graduates, and working professionals who want to start or grow a career in data analytics and business intelligence.",
  },
  {
    q: "3. What will I learn in this course?",
    a: "You will learn Excel, SQL, Python (Pandas, NumPy), data visualization tools like Power BI and Tableau, and real-time data analysis projects.",
  },
  {
    q: "4. Are there any prerequisites?",
    a: "No strict prerequisites are required. Basic computer knowledge and logical thinking are enough to start.",
  },
  {
    q: "5. Is the course online or offline?",
    a: "Fazo Academy offers both online and classroom training options for Data Analysis training.",
  },
  {
    q: "6. How long is the course?",
    a: "The duration varies from a few weeks to a few months depending on the learning schedule and batch type.",
  },
  {
    q: "7. What job roles can I apply for after this course?",
    a: "You can apply for roles like Data Analyst, Business Analyst, Reporting Analyst, and BI Analyst.",
  },
  {
    q: "8. Does Fazo Academy provide placement support?",
    a: "Yes, we provide dedicated placement assistance through our career services and hiring partner network.",
  },
];

  // ---- Training Method FAQs ----
  const trainingFAQs = [
    {
      q: "1. What training methods does Fazo Academy use?",
      a: "We use interactive lectures, projects, peer collaboration, mentorship, and flexible learning options.",
    },
    {
      q: "2. Are the lectures interactive?",
      a: "Yes, our lectures encourage active engagement and collaboration between students and instructors.",
    },
    {
      q: "3. How are hands-on projects incorporated?",
      a: "Projects simulate real-world challenges to reinforce learning and build strong portfolios.",
    },
    {
      q: "4. Is peer collaboration encouraged?",
      a: "Yes, team collaboration helps share knowledge and improve learning outcomes.",
    },
    {
      q: "5. Do students receive one-on-one mentorship?",
      a: "Yes, personalized mentorship is part of every student’s journey at Fazo Academy.",
    },
    {
      q: "6. How is the curriculum updated?",
      a: "Our curriculum is regularly revised to reflect the latest industry technologies and best practices.",
    },
    {
      q: "7. Does Fazo Academy offer flexible learning options?",
      a: "Yes, we offer part-time, full-time, online, and in-person training modes.",
    },
    {
      q: "8. Are there opportunities for practical application?",
      a: "Absolutely. Students work on coding exercises, simulations, and real-world case studies.",
    },
  ];

  const categories = [
    { title: "FAQs about Fazo Academy", data: academyFAQs },
    { title: "FAQs about Data Analysis Course", data: dataAnalysisFAQs },
    { title: "FAQs about Training Methods", data: trainingFAQs },
  ];

  return (
    <div className="faq-section-one">
      <div className="container">
        <section className="section-margin" data-aos="fade-up">
          <div className="headlines-for-all">
            <h4>
              <span>Frequently</span> Asked Questions
            </h4>
            <p>
              Find answers to the most common questions about our courses,
              learning process, certifications, and career support.
            </p>
          </div>
        </section>

        <div className="faq-container">
          {categories.map((cat, catIndex) => (
            <div
              className="faq-category"
              key={catIndex}
              // data-aos="fade-up"
              // data-aos-delay={catIndex * 200}
            >
              <h2 className="faq-title">{cat.title}</h2>

              {cat.data.map((item, index) => {
                const itemIndex = `${catIndex}-${index}`;
                const isOpen = openIndex === itemIndex;

                return (
                  <div className="faq-item" key={itemIndex}>
                    <button
                      className={`faq-question ${isOpen ? "active" : ""}`}
                      onClick={() => toggleFAQ(itemIndex)}
                      // data-aos="fade-up"
                    >
                      {item.q}
                      <span className="arrow">{isOpen ? "▲" : "▼"}</span>
                    </button>

                    <div
                      className="faq-answer"
                      style={{
                        maxHeight: isOpen ? "500px" : "0",
                        opacity: isOpen ? "1" : "0",
                        transition: "all 0.4s ease",
                      }}
                    >
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
